import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";

import useContentful from "../../hooks/use-contenful";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import BlockRightImage from "../../components/BlockRightImage";
import Accordion from "../../components/Accordion";
import Block2ColumnsText from "../../components/Block2ColumnsText";
import Notification from "../../components/Notification";
import Block3Columns from "../../components/Block3Columns";
import ModalFixed from "../../components/ModalFixed";
import Gallery from "../../components/Gallery";
import BlockLeftImage from "../../components/BlockLeftImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";

const query = `
query 
{
    videoTemplate(id: "7jgpMsCmEsOho6PZCz96YW") {
    image{url, title}
      contentBlock1{json}
       contentBlock2{json}
           imageBlock2{url, title}
    contentBlock3{json}
    contentBlock4{json}
    imageBlock4{url, title}
    contentBlock5{json}
    imageBlock5{url, title}
    contentBlock6{json}
  imageBlock7{url, title}
    contentBlock7{json}
    contentBlock8{json}
    contentBlock9{json}
    contentBlock10{json}
    contentBlock11{json}
      contentBlock12{json}
      contentBlock13{json}
    imageBlock12{url, title}
       galleryCollection{
        items{url title}
         }     
        gallery2Collection{
        items{url title}
        }
         gallery3Collection{
        items{url title}
        }
   
    }
  
}
`;

function Compentencias() {
  let { data, errors } = useContentful(query);
  if (errors)
    return <span>{errors.map((error) => error.message).join(",")}</span>;
  if (!data) return <p>Loading...</p>;

  return (
    <>
      <div className="margin">
        <BlockImageCabecera
          src={data.videoTemplate.image.url}
          title={documentToReactComponents(
            data.videoTemplate.contentBlock1.json
          )}
        ></BlockImageCabecera>
      </div>

      <div>
        <div className="relative">
          <Notification
            content={
              <>
                {documentToReactComponents(
                  data.videoTemplate.contentBlock6.json
                )}
              </>
            }
          ></Notification>
          <ModalFixed
            title="Proceso de inscripción 🖊️"
            color="#37994f"
            content={
              <>
                <Gallery
                  gallery={data.videoTemplate.galleryCollection.items}
                  width="450"
                ></Gallery>
              </>
            }
          ></ModalFixed>
        </div>
        <Breadcumbs
          content={
            <>
              <NavLink to="/competencias">Competencias Específicas</NavLink>
            </>
          }
        ></Breadcumbs>

        <div className="icon70 padding">
          <center>
            {" "}
            <Block3Columns
              col1={
                <>
                  <img src={data.videoTemplate.imageBlock2.url}></img>

                  {documentToReactComponents(
                    data.videoTemplate.contentBlock2.json
                  )}
                  <Accordion
                    title="Excepciones de asignaturas"
                    content={
                      <>
                        {documentToReactComponents(
                          data.videoTemplate.contentBlock3.json
                        )}
                      </>
                    }
                  ></Accordion>
                </>
              }
              col2={
                <>
                  <img src={data.videoTemplate.imageBlock4.url}></img>

                  {documentToReactComponents(
                    data.videoTemplate.contentBlock4.json
                  )}
                  <Accordion
                    title="Calendario académico"
                    content={
                      <>
                        {documentToReactComponents(
                          data.videoTemplate.contentBlock13.json
                        )}
                      </>
                    }
                  ></Accordion>
                </>
              }
              col3={
                <>
                  <img src={data.videoTemplate.imageBlock5.url}></img>

                  {documentToReactComponents(
                    data.videoTemplate.contentBlock5.json
                  )}
                </>
              }
            ></Block3Columns>
          </center>
        </div>
      </div>

      <BlockRightImage
        src={data.videoTemplate.imageBlock7.url}
        content={
          <>
            {documentToReactComponents(
                    data.videoTemplate.contentBlock7.json
                  )}
          </>
        }
      ></BlockRightImage>

      <div className="relative">
        <div className="padding graybg " id="validacion">
          <center>
            <div className="width500">
              {documentToReactComponents(data.videoTemplate.contentBlock8.json)}
            </div>
            <div className="layout6">
              {documentToReactComponents(data.videoTemplate.contentBlock9.json)}
            </div>
            <h3>
              <b>Proceso</b> de legalización
            </h3>
          </center>

          <h2>Modalidad a distancia y en línea</h2>

          <p>
            Para realizar el trámite de legalización de la validacion de
            conocimientos, es necesario que apruebes la validación
          </p>
          <div className="relative">
            <div>
              {" "}
              <Block2ColumnsText
                col1={documentToReactComponents(
                  data.videoTemplate.contentBlock10.json
                )}
                col2={documentToReactComponents(
                  data.videoTemplate.contentBlock11.json
                )}
              ></Block2ColumnsText>
            </div>
          </div>
        </div>
        <ModalFixed
          title="Proceso de legalización 👍"
          color="#359ae0"
          content={
            <>
              <Gallery
                gallery={data.videoTemplate.gallery2Collection.items}
                width="450"
              ></Gallery>
            </>
          }
        ></ModalFixed>
      </div>
      <div className=" relative" id="homologacion">
        <div className="icon300">
          <BlockLeftImage
            src={data.videoTemplate.imageBlock12.url}
            content={documentToReactComponents(
              data.videoTemplate.contentBlock12.json
            )}
          ></BlockLeftImage>
        </div>

        <ModalFixed
          title="Proceso de homologación ✍🏼️"
          color="#d67d3a"
          content={
            <>
              <Gallery
                gallery={data.videoTemplate.gallery3Collection.items}
                width="450"
              ></Gallery>
            </>
          }
        ></ModalFixed>
      </div>
    </>
  );
}

export default Compentencias;
